module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-nav-wrapper"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('comb.myAudition')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('word.total')) + " " + _vm._s(_vm.totalCount) + " " + _vm._s(_vm.$t('word.item')))])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-wrapper"
  }, [_c('button', {
    class: {
      'active': _vm.statusCode === 0
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(0, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.all')))])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 1
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(1, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.addition')))])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 2
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(2, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.selecting')))])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 3
    },
    on: {
      "click": function($event) {
        _vm.getTaskList(3, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.AuditionFailure')))])])])]), _vm._v(" "), (_vm.totalCount === 0 && _vm.statusCode === 0) ? _c('div', {
    staticClass: "copyright-empty-task-list"
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("为您推荐")]), _vm._v(" "), _c('div', {
    staticClass: "recommend-wrapper"
  }, _vm._l((_vm.recommendList), function(recommend, index) {
    return _c('a', {
      staticClass: "recommend-item",
      attrs: {
        "target": "_blank",
        "href": ((_vm.$store.state.A_PC_HOST) + "/requirement/" + (recommend.requirementId) + "/candidate")
      }
    }, [_c('img', {
      ref: "recommendImg",
      refInFor: true,
      attrs: {
        "src": _vm.$store.state.UPLOAD_IMG_HOST + recommend.coverPath
      },
      on: {
        "error": function($event) {
          _vm.setDefaultBookCoverImg(index, 'recommendImg')
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content-wrapper"
    }, [_c('div', {
      staticClass: "payment-wrapper"
    }, [_c('span', {
      staticClass: "payment"
    }, [_vm._v(_vm._s(_vm.getPayment(recommend)))]), _vm._v(" "), _c('span', {
      staticClass: "payment-label"
    }, [_vm._v(_vm._s(_vm.getPaymentLabel(recommend)))])]), _vm._v(" "), _c('span', {
      staticClass: "requirement-name"
    }, [_vm._v(_vm._s(recommend.requirementName))]), _vm._v(" "), _c('span', {
      staticClass: "author-name"
    }, [_vm._v(_vm._s(recommend.authorName) + " 著")]), _vm._v(" "), _c('span', {
      staticClass: "category-label"
    }, [_vm._v(_vm._s(recommend.categoryName))]), _vm._v(" "), _c('div', {
      staticClass: "audition-wrapper"
    }, [_c('span', [_vm._v("海选剩余" + _vm._s(recommend.sampleRemainTime))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(recommend.candidateOrTaskWorkNum) + "人参选")])])])])
  })), _vm._v(" "), _c('p', {
    staticClass: "no-task"
  }, [_vm._v("您可以通过"), _c('a', {
    attrs: {
      "href": ((_vm.$store.state.A_PC_HOST) + "/requirementview")
    }
  }, [_vm._v("参加海选")]), _vm._v("或"), _c('router-link', {
    attrs: {
      "to": {
        name: 'anchorMyVoiceTag'
      }
    }
  }, [_vm._v("添加声音标签")]), _vm._v("获得更多播讲机会")], 1)]) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.pageLoading),
      expression: "pageLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "copyright-tasks-list-wrapper"
  }, _vm._l((_vm.taskList), function(item, index) {
    return _c('div', {
      staticClass: "task-item"
    }, [_c('div', {
      staticClass: "title"
    }, [(item.viewStatusId > 2) ? _c('span', {
      staticClass: "status"
    }, [_vm._v("海选失败")]) : _c('span', {
      staticClass: "status"
    }, [_vm._v(_vm._s(item.viewStatusName))]), _vm._v(" "), (item.viewStatusId === 1) ? _c('span', [_vm._v(_vm._s(item.sampleRemainTime))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "task-content-wrapper"
    }, [(item.coverPath) ? _c('img', {
      ref: "img",
      refInFor: true,
      staticClass: "task-cover",
      attrs: {
        "src": _vm.$store.state.UPLOAD_IMG_HOST + item.coverPath
      },
      on: {
        "error": function($event) {
          _vm.setDefaultBookCoverImg(index, 'img')
        }
      }
    }) : _c('img', {
      staticClass: "task-cover",
      attrs: {
        "src": _vm.$store.state.IMG_HOST + 'bookCoverDefault.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "task-content",
      class: {
        'task-content-single': item.requirementId
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('span', {
      staticClass: "task-name"
    }, [_vm._v(_vm._s(item.requirementName))]), _vm._v(" "), (item.author) ? _c('div', [_c('span', {
      staticClass: "task-anchor"
    }, [_vm._v(_vm._s(item.categoryName))])]) : _vm._e(), _vm._v(" "), (item.viewStatusId < 3) ? _c('span', {
      staticClass: "category-label"
    }, [_vm._v(_vm._s(item.candidateOrTaskWorkNum) + "人参与")]) : _c('span')]), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [_c('a', {
      staticClass: "check-task",
      attrs: {
        "href": ((_vm.$store.state.A_PC_HOST) + "/requirement/" + (item.requirementId) + "/candidate"),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('word.check')))])])])])])
  })), _vm._v(" "), (_vm.totalPage >= 2) ? _c('div', {
    staticClass: "center-tasks-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-count": _vm.totalPage,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9dc3ea22!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/center/AuditionTasks.vue
// module id = 402
// module chunks = 0